import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../../../components/BaseComponent';
import { List, Row, Cell } from '../../../components/List';

const Container = styled.div``;

/* eslint-disable react/prefer-stateless-function */
class UserHeaderComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {}

  getPropertyValue(name, _default = null) {
    let prop = this.props.user.properties.find(p => p.name.name === name)?.value ?? _default;
    return prop;
  }

  render() {
    const user = this.props.user;

    return (
      <Container onClick={this.props.onClick}>
        <List>
          <Row>
            <Cell>{this.lbl('name')}</Cell>
            <Cell>
              {this.getPropertyValue('name')} {this.getPropertyValue('surname')}
            </Cell>
          </Row>

          <Row>
            <Cell>{this.lbl('email')}</Cell>
            <Cell>{user.email_address}</Cell>
          </Row>
        </List>
      </Container>
    );
  }
}

UserHeaderComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const UserHeader = compose(
  withConnect,
  withRouter,
)(UserHeaderComp);
